import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const myWalletFn = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.myWallet, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
